<template>
  <div class="goods_index">
    <el-breadcrumb separator="/" slot="breadcrumb" class="breadcrumb-bg">
      <el-breadcrumb-item :to="{ path: '/admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品</el-breadcrumb-item>
    </el-breadcrumb>
      <div class="header-top-15">
          <el-card class="box-card" style="margin-top: 15px">
              <el-form  :model="form">
                  <el-form-item label="搜索">
                      <el-input size="medium" v-model="form.goods_title" placeholder="商品名称或货号" @input="search" style="width: 50%"></el-input>
                  </el-form-item>



              </el-form>
          </el-card>
      </div>

    <el-table
      :data="result.data"
      stripe
      style="width: 100%; margin-top: 10px"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" label="ID" width="180"> </el-table-column>
      <el-table-column prop="id" label="ID" width="180"> </el-table-column>
      <el-table-column prop="title" label="商品名称" width="180"> </el-table-column>
        <el-table-column prop="art_num" label="货号" width="180"> </el-table-column>
      <el-table-column prop="price" label="市场价"> </el-table-column>
        <el-table-column prop="tag_price" label="吊牌价"> </el-table-column>
        <el-table-column label="">
            <template slot-scope="scope">
                <el-button size="mini" type="info"
                           v-if="scope.row.status==0"
                           @click="updownGoods(scope.row.id, 1)"
                >上架</el-button
                >
                <el-button size="mini" type="warning"
                           v-if="scope.row.status==1"
                           @click="updownGoods(scope.row.id, 0)"
                >下架</el-button
                >

            </template>
        </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">

            <el-row>
                <el-col :span="12"> <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
                >
                   </el-col>
                <el-col :span="12"> <el-button
                        size="mini"
                        type="danger"
                        @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
                ></el-col>

            </el-row>

        </template>
      </el-table-column>
    </el-table>

    <div class="page_box_num">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="result.totalpages"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      multipleSelection: [],
        form:{
            goods_title:"",
            type:'',
        },



    };
  },
  methods: {
    ...mapActions({
      getGoodsDataIndexAction: "getGoodsDataIndexAction",
      deleteGoodsAction: "deleteGoodsAction",
      updownGoodsAction:"updownGoodsAction"
    }),

    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },

    changePage(e) {
      this.page = e;
      this.changePageData(e);
    },
    changePageData(page) {
      this.page = page;
      console.log("tag", this.page);
      this.getGoodsDataIndexAction({ page: page,title:this.form.goods_title });
    },
    handleEdit(index, row) {
      console.log(index, row);
      this.$router.push({ name: "goods_edit", params: { id: row.id } });
    },
    handleDelete(index, row) {
      console.log(index, row);
      this.deleteGoodsAction({ id: row.id });
    },
    search(){

        this.changePageData(1)
    },
   updownGoods(id,val){
        this.updownGoodsAction({id:id,value:val})

   }
  },
  mounted() {
    this.changePageData(this.page);
  },
  computed: {
    //   ...mapState({dataIndex:"index.dataIndex"}),
    ...mapState({
      result: (state) => state.goods.result,
    }),
    page: {
      get() {
        return this.$store.state.goods.page;
      },
      set(val) {
        this.$store.state.goods.page = val;
      },
    },
  },
  watch: {
    result(newdata) {
      if (newdata.code == 302) {
        this.$message({
          showClose: true,
          message: "商品删除成功",
          type: "success",
        });
        this.changePageData(1);
      }

        if (newdata.code == 303) {
            this.$message({
                showClose: true,
                message: newdata.tips,
                type: "success",
            });
            this.changePageData(1);
        }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.page_box_num {
  background-color: #fff;
  padding: 8px;
}
</style>
